import { jsonldTelephone } from './JsonldStore';

export const updateJsonldTelephone = (value) => jsonldTelephone.update((oldValue) => value);
